import styles from "./styles.module.sass";

interface ActionsFooterProps {
  left?: React.ReactNode;
  right?: React.ReactNode;
}

export function ActionsFooter({ left, right }: ActionsFooterProps) {
  return (
    <div className={styles.ActionsFooter}>
      {left}
      {right}
    </div>
  );
}
